export const FORM_DATA_KEYS_MAP = {
  policyDate: 'policy_date',
  travelType: 'travelType',
  numadults: 'numadults',
  nationalityCode: 'nationalityCode',
  nationalityName: 'nationalityName',
}

export const retryCount = 3